module.exports = __webpack_public_path__ + "img/square-insta.935f50d0.png";